export class TimeoutException extends Error {
  constructor(public readonly operationType: 'sendRequest' | 'sendNotification' = 'sendRequest') {
    super(`Operation ${operationType} timed out`)
  }

  static isTimeoutException(error: unknown): error is TimeoutException {
    return error instanceof this
  }
}
